var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "sidebar" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-inner" }, [
      _c(
        "nav",
        { staticClass: "primary-nav" },
        [
          _c(
            "router-link",
            { attrs: { id: "quoteNav", tag: "a", to: "/quote" } },
            [
              _c("truck-icon", { staticClass: "icon", attrs: { size: "20" } }),
              _vm._v(" "),
              _c("span", { staticClass: "nav-label" }, [_vm._v("Quote")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { id: "logoutNav", tag: "a", to: "/logout", exact: "" } },
            [
              _c("lock-icon", { staticClass: "icon", attrs: { size: "20" } }),
              _vm._v(" "),
              _c("span", { staticClass: "nav-label" }, [_vm._v("Logout")])
            ],
            1
          ),
          _vm._v(" "),
          _c("b-tooltip", {
            attrs: {
              target: "quoteNav",
              title: "Quote",
              placement: "'right'",
              boundary: "'window"
            }
          }),
          _vm._v(" "),
          _c("b-tooltip", {
            attrs: {
              target: "logoutNav",
              title: "Logout",
              placement: "'right'",
              boundary: "'window"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "brand d-flex align-items-center" }, [
      _c("img", {
        staticClass: "main-logo",
        attrs: { src: "/static/primary-logo.png", alt: "Nutrinza" }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "mobile-logo",
        attrs: { src: "/static/mobile-logo.png", alt: "Nutrinza" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c2e56ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c2e56ab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSidebar.vue
// module id = E4gl
// module chunks = 1